import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import LoginForm from './components/LoginForm';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user is already logged in
    const storedUser = localStorage.getItem('tbf_user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        const roleRoutes = {
          admin: '/admin-dashboard',
          staff: '/admin-dashboard',
          region_admin: '/admin-dashboard',
          'team-manager': '/team-registration',
          team_manager: '/admin-dashboard',
          player: '/player-registration',
          official: '/match-management'
        };
        
        // Redirect to appropriate dashboard
        const redirectTo = roleRoutes[userData.role] || '/admin-dashboard';
        navigate(redirectTo, { replace: true });
      } catch (error) {
        // Clear invalid stored data
        localStorage.removeItem('tbf_user');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background Image with White Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/assets/images/login-background.png)',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="absolute inset-0 bg-white/45"></div>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        {/* Header */}
        <header className="w-full py-6 px-4 lg:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <img
                  src="/assets/images/tbf-logo-transparent.png"
                  alt="Tanzania Basketball Federation"
                  className="h-14 w-auto object-contain drop-shadow-sm"
                />
                <div>
                  <h1 className="text-lg font-bold text-white">TBF</h1>
                  <p className="text-xs text-white/90">Registration System</p>
                </div>
              </div>
              
              <div className="text-right">
                <p className="text-sm font-medium text-white">Tanzania Basketball Federation</p>
                <p className="text-xs text-white/90">Official Management Portal</p>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content - Centered Login Card */}
        <main className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            <div className="bg-card border border-border rounded-xl p-8 card-shadow">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-2">
                  Tanzania Basketball Federation
                </h2>
                <p className="text-muted-foreground">
                  Management and Administration Platform
                </p>
              </div>

              <LoginForm />
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="w-full py-6 px-4 lg:px-6 border-t border-white/20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
              <div className="text-center sm:text-left">
                <p className="text-sm text-white">
                  © {new Date().getFullYear()} Tanzania Basketball Federation. All rights reserved.
                </p>
                <p className="text-xs text-white/90 mt-1">
                  Powered by TBF Registration System v2.1
                </p>
              </div>
              
              <div className="flex items-center space-x-6 text-xs text-white">
                <Link to="/privacy-policy" className="hover:text-white/80 transition-colors">
                  Privacy Policy
                </Link>
                <Link to="/terms-of-service" className="hover:text-white/80 transition-colors">
                  Terms of Service
                </Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LoginPage;